import { cva, type VariantProps } from 'class-variance-authority'
import type { ComponentPropsWithRef } from 'react'
import s from './Badge.module.css'

/**
 * Badge d'état — la pastille à point du prototype (`.badge`) : « Sans RDV »,
 * « À valider », « Conforme »… Les quatre tons couvrent les tokens `--status-*`.
 *
 * Purement informatif : pour un compteur, voir `CountBadge` ; pour un libellé de
 * catégorie, `Tag` ; pour une équipe, `Chip`.
 */
const badge = cva(s.root, {
  variants: {
    tone: {
      ok: s.toneOk,
      warn: s.toneWarn,
      info: s.toneInfo,
      bad: s.toneBad,
      neutral: s.toneNeutral,
    },
  },
  defaultVariants: { tone: 'info' },
})

export type BadgeProps = ComponentPropsWithRef<'span'> & VariantProps<typeof badge>
export type BadgeTone = NonNullable<VariantProps<typeof badge>['tone']>

export function Badge({ tone, className, ...props }: BadgeProps) {
  return <span className={badge({ tone, className })} {...props} />
}
